<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="100%"
		height="100%"
		viewBox="0 0 40 40"
		fill="none"
	>
		<path
			d="M10 30.6667V9.33337C10 8.78109 10.4477 8.33337 11 8.33337H15.6667C16.2189 8.33337 16.6667 8.78109 16.6667 9.33337V30.6667C16.6667 31.219 16.2189 31.6667 15.6667 31.6667H11C10.4477 31.6667 10 31.219 10 30.6667Z"
			fill="black"
		/>
		<path
			d="M23.3333 30.6667V9.33337C23.3333 8.78109 23.781 8.33337 24.3333 8.33337H29C29.5523 8.33337 30 8.78109 30 9.33337V30.6667C30 31.219 29.5523 31.6667 29 31.6667H24.3333C23.781 31.6667 23.3333 31.219 23.3333 30.6667Z"
			fill="black"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M11.25 9.58337V30.4167H15.4167V9.58337H11.25ZM8.75 9.33337C8.75 8.09073 9.75736 7.08337 11 7.08337H15.6667C16.9093 7.08337 17.9167 8.09073 17.9167 9.33337V30.6667C17.9167 31.9094 16.9093 32.9167 15.6667 32.9167H11C9.7574 32.9167 8.75 31.9094 8.75 30.6667V9.33337ZM24.5833 9.58337V30.4167H28.75V9.58337H24.5833ZM22.0833 9.33337C22.0833 8.09077 23.0906 7.08337 24.3333 7.08337H29C30.2427 7.08337 31.25 8.09078 31.25 9.33337V30.6667C31.25 31.9094 30.2427 32.9167 29 32.9167H24.3333C23.0906 32.9167 22.0833 31.9094 22.0833 30.6667V9.33337Z"
			fill="black"
		/>
	</svg>
</template>
